import * as React from 'react';

const SvgIntroRejected = (props) => (
  <svg
    width={42}
    height={42}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_d_967_3968)">
      <circle cx={21} cy={18} r={12} fill="#F74343" />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.3333 14.6667C23.3333 16.1394 22.1394 17.3333 20.6667 17.3333C19.1939 17.3333 18 16.1394 18 14.6667C18 13.1939 19.1939 12 20.6667 12C22.1394 12 23.3333 13.1939 23.3333 14.6667ZM25.3333 21.3333C25.3333 22.8061 23.244 24 20.6667 24C18.0893 24 16 22.8061 16 21.3333C16 19.8606 18.0893 18.6667 20.6667 18.6667C23.244 18.6667 25.3333 19.8606 25.3333 21.3333ZM25.0202 14.9798C24.825 14.7845 24.5084 14.7845 24.3131 14.9798C24.1179 15.175 24.1179 15.4916 24.3131 15.6869L25.2929 16.6667L24.3131 17.6464C24.1179 17.8417 24.1179 18.1583 24.3131 18.3536C24.5084 18.5488 24.825 18.5488 25.0202 18.3536L26 17.3738L26.9798 18.3536C27.175 18.5488 27.4916 18.5488 27.6869 18.3536C27.8821 18.1583 27.8821 17.8417 27.6869 17.6464L26.7071 16.6667L27.6869 15.6869C27.8821 15.4916 27.8821 15.175 27.6869 14.9798C27.4916 14.7845 27.175 14.7845 26.9798 14.9798L26 15.9596L25.0202 14.9798Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_967_3968"
        x={0}
        y={0}
        width={42}
        height={42}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius={1}
          operator="dilate"
          in="SourceAlpha"
          result="effect1_dropShadow_967_3968"
        />
        <feOffset dy={3} />
        <feGaussianBlur stdDeviation={4} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_967_3968"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_967_3968"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default SvgIntroRejected;
